import { render, staticRenderFns } from "./CreateVoiceBlastTemplate.vue?vue&type=template&id=367bc278"
import script from "./CreateVoiceBlastTemplate.vue?vue&type=script&lang=js"
export * from "./CreateVoiceBlastTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports